export const CALL_ERROR_STATUSES = ["failed", "rejected", "delivery_failed"] as const;
export const CALL_ANOMALY_STATUSES = [...CALL_ERROR_STATUSES, "cancelled"] as const;

export interface AdminErrorCounts {
  requests: number;
  errors: number;
  failed: number;
  rejected: number;
  deliveryFailed: number;
  cancelled: number;
}

export interface AdminErrorDimension {
  id: string | null;
  label: string | null;
  requests: number;
  errors: number;
}

export interface AdminErrorOverview {
  totals: AdminErrorCounts;
  trend: Array<AdminErrorCounts & { day: string }>;
  reasons: Array<{ errorCode: string | null; count: number; lastOccurredAt: string }>;
  models: AdminErrorDimension[];
  channels: AdminErrorDimension[];
}
